import React from 'react';
import background from '../../assets/coffee-beans.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';


class PromptCoffee extends React.Component {
  render () { 
   return(
  <ReusableAskearth             
    
        tag="ASK EARTH"
        description01="Is coffee in danger?"

        
        background={background}
     />

  );
 }
}   

export default PromptCoffee;
